module.exports = __webpack_public_path__ + "img/Da Pu Teppanyaki.2e1e1590.svg";